const config = {
  userPoolId: "us-east-1_uhsfsn6Gd",
  userPoolClientId: "58ubfebtgmrn0v73gc01mpoon",
  apiEndpoint: "/api/chat",
};

export default config;
